import { RequiredFieldError } from '../../validation/errors/required-field-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'

export class RequiredFieldValidation implements FieldValidation {
  readonly field: string

  constructor (field: string) {
    this.field = field
  }

  validate (value: string): Error | null {
    return value ? null : new RequiredFieldError()
  }
}
